<template>
  <div class="flex items-center">
    <div class="pay-money">
      <div class="pay-money__unit">{{ price.prefix }}</div>
      <div class="pay-money__number">
        <RollingNumber :precision="2" :value="discountPrice" />
      </div>
    </div>
    <div class="pay-right">
      <div class="pay-discount">{{ discount }}折</div>
      <div class="pay-original">{{ price.prefix }}{{ price.value }}</div>
    </div>
  </div>
</template>

<script setup lang="ts" name="PayMoneyDiscount">
import { formatPrice } from '@rendora/common/utils/transform';
import RollingNumber from '@rendora/design/components/rolling-number/index.vue';
import { computed } from 'vue';

const props = defineProps<{ text: number; discount: number }>();
const price = computed(() => formatPrice(props.text));

// const paymentStore = usePayment();
// const { isAcceptedDiscount } = storeToRefs(paymentStore);

// const showRightPrice = computed(() => {
//   return isAcceptedDiscount.value;
// });
const discounted = computed(() => props.discount / 100);

// 配合后端， 应对 三位小数情况下，第三位小数不论是什么 第二位小数都进一  和后端计算出来的保持一致
function roundUpToTwoDecimals(num: number) {
  const multiplied = num * 100;
  const rounded = Math.ceil(multiplied);
  return rounded / 100;
}

const discountPrice = computed(() => {
  // 保留两位小数 并最后一位进上去
  const roundUpPrice = roundUpToTwoDecimals(price.value.value * discounted.value);
  return roundUpPrice;
});
</script>

<style lang="scss">
.pay-money {
  display: flex;
  color: var(--x-error-6);
  font-size: 28px;
  font-weight: 500;
  line-height: 40px;
  margin-right: 7px;
}
.pay-discount {
  color: var(--x-back-1);
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  padding: 0 3px;
  font-weight: 500;
  background: var(--x-error-6);
}
.pay-original {
  color: var(--x-text-5);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-decoration: line-through;
}
</style>
